import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PollSingleAbstract } from '../../../../../abstracts/poll-single.abstract';
import { FormGroup } from '@angular/forms';
import { IPollAnswers } from '../../../../../models/poll.model';
import { ToastController } from 'ionic-angular';
import { IClientConfig } from '../../../../../models/client.model';
import { has } from 'lodash';

@Component({
  selector: 'app-event-single-question',
  templateUrl: 'event-single-question.html'
})

export class EventSingleQuestionComponent extends PollSingleAbstract implements OnInit, OnChanges {
  public form: FormGroup;

  @Input('clientConfig')
  public clientConfig: IClientConfig;

  @Input('answers')
  public answers: IPollAnswers[];

  @Input('questionId')
  public questionId: string;

  @Input('userAnswer')
  public userAnswer: any;

  @Input('language')
  public language: string;

  @Input('lastQuestion')
  public lastQuestion: boolean;

  @Input('userHasRecord')
  public userHasRecord: boolean;

  constructor(
    public toastCtrl: ToastController
  ) {
    super(toastCtrl);
  }

  ngOnInit() {
    this.buildForm();
    this.patchForm({ id: this.questionId, value: this.userAnswer });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (has(changes, 'questionId') && changes.questionId.firstChange === false) {
      this.patchForm({ id: this.questionId, value: this.userAnswer || '' });

    }

  }

  public checkAnswers() {
    if (this.userAnswer) {
      this.patchForm({ id: this.questionId, value: this.userAnswer });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/poll-event/components/event-poll-questions/event-single-question/event-single-question.ts